/**
 * 輸送希望時間タイプの定数定義
 */
export const yusouKibouJikanType = {
  // 終日
  all_day: {
    value: 'all_day',
    label: '終日',
    description: '時間の指定なし（終日対応可能）',
  },

  // AM
  am: {
    value: 'am',
    label: 'AM',
    description: '午前中の輸送を希望',
  },

  // PM
  pm: {
    value: 'pm',
    label: 'PM',
    description: '午後の輸送を希望',
  },

  // その他
  other: {
    value: 'other',
    label: 'その他',
    description: 'その他の時間指定',
  },
}

/**
 * 輸送希望時間タイプの配列（選択肢として使用）
 */
export const yusouKibouJikanTypeOptions = [
  yusouKibouJikanType.all_day,
  yusouKibouJikanType.am,
  yusouKibouJikanType.pm,
  yusouKibouJikanType.other,
]

/**
 * 輸送希望時間タイプの値から対応するオブジェクトを取得
 * @param {string} value
 * @returns {object|null}
 */
export const getYusouKibouJikanTypeByValue = (value) => {
  return (
    Object.values(yusouKibouJikanType).find((type) => type.value === value) ||
    null
  )
}

/**
 * セレクトボックス等で使用する{text: label, value: value}形式の配列を取得
 * @returns {Array<{text: string, value: string}>}
 */
export const getYusouKibouJikanTypeSelectOptions = () => {
  return Object.values(yusouKibouJikanType).map((type) => ({
    text: type.label,
    value: type.value,
  }))
}

/**
 * その他の希望時間を希望しているかを判定
 * @param {string} kibouJikanType 希望時間タイプの値
 * @returns {boolean}
 */
export const isKibouJikanReason = (kibouJikanType) => {
  return kibouJikanType === yusouKibouJikanType.other.value
}

export default yusouKibouJikanType



// WEBPACK FOOTER //
// ./src/constants/yusouKibouJikanType.js